import { useParams } from "react-router";

export function useIdParam<T = string>(paramName = "id") {
  const params = useParams();
  return params[paramName] as T;
}
